/**
 * @typedef LIFFAppData
 * @property {string} liffId
 * @property {object} view
 * @property {'compact'|'tall'|'full'} view.type
 * @property {string} view.url
 * @property {string} description
 * @property {object} features
 * @property {boolean} features.ble
 */
